import script from "./TheWinners.vue?vue&type=script&setup=true&lang=js"
export * from "./TheWinners.vue?vue&type=script&setup=true&lang=js"

import "./TheWinners.vue?vue&type=style&index=0&id=445c32cd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-445c32cd"]])

export default __exports__